// extracted by mini-css-extract-plugin
export default {"title":"CourtshipLineScreen_title__kUlaR"};